import { VideoAspectRatio } from 'common/types/entities/VideoInterface'
import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import { getPaddingForRatio } from 'src/shared/utils/video-aspect-ratio'
import styled from 'styled-components'

type EmbedPlayerUiProps = BorderEntityInterface & {
  boxShadow?: string
  mobileBoxShadow?: string
  skipIframeStyles?: boolean
  aspectRatio?: VideoAspectRatio
}

export const TikTokEmbedPlayerUi = styled.div<EmbedPlayerUiProps>`
  ${borderCss};
  ${boxShadowCss};
  ${p => p.theme.phone} {
    ${mobileBorderCss};
    ${mobileBoxShadowCss};
  }
`

const EmbedPlayerUi = styled.div<EmbedPlayerUiProps>`
  position: relative;
  padding-top: 0;
  height: auto;
  overflow: hidden;

  &:has(>iframe) {
    padding-bottom: ${p => getPaddingForRatio(p.aspectRatio)}%;
  }

  & iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-width: 0;
  }
  ${borderCss};
  ${boxShadowCss};
  ${p => p.theme.phone} {
    ${mobileBorderCss};
    ${mobileBoxShadowCss};
  }
`

export default EmbedPlayerUi
